<form class="geaui-grid-col-12" [formGroup]="renameForm" (ngSubmit)="save()">
  <div class="dialog-body flex flex-column">
    <geaui-input-v3
      [id]="'currentFileName'"
      [label]="'Current File Name'"
      [formGroupInput]="renameForm"
      [formFieldName]="'currentFileName'"
      [disabled]="true"
      floatLabelType="always">
    </geaui-input-v3>
    <geaui-input-v3
      [id]="'newFileName'"
      [label]="'New File Name'"
      [placeholder]="'Enter new file name'"
      [formGroupInput]="renameForm"
      [formFieldName]="'newFileName'"
      floatLabelType="always">
    </geaui-input-v3>
  </div>
  <p-divider />
  <div class="p-dialog-footer">
    <geaui-button-v3 [type]="'secondary'" (click)="close()">Cancel</geaui-button-v3>
    <geaui-button-v3 [disabled]="!renameForm.valid" [sending]="renamingFile()" (click)="save()">Rename</geaui-button-v3>
  </div>
</form>
